import React, { useEffect, useRef, useState } from 'react'
import styles from './LangDropdown.module.sass'
import useTrans from '@hooks/useTrans'
import { Check, ChevronDown, ChevronUp } from '@components/icons'
import WLink from '../WLink/WLink'
import useLocale from '@hooks/useLocale'
//import { trackingGAevent, uniformData } from '@utils/gtm'

interface Props {
  items?: any[]
  variant?: 'header' | 'navmobile'
  className?: string
  position?: string
  onClick?: (label: string) => void
}

const LangDropdown = (props: Props) => {
  const {
    items = [],
    variant = 'header',
    className = '',
    position = '',
    onClick = undefined,
  } = props

  const t = useTrans()
  const { lang } = useLocale()
  const ref = useRef(null)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const keyDownHandler = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault()
        setOpen(false)
      }
    }

    const mouseDownHandler = (event) => {
      if (!ref.current?.contains(event.target)) {
        setOpen(false)
      }
    }
    document.addEventListener('keydown', keyDownHandler)
    document.addEventListener('mousedown', mouseDownHandler)
    return () => {
      document.removeEventListener('mousedown', mouseDownHandler)
      document.removeEventListener('keydown', keyDownHandler)
    }
  }, [])

  const handleClickLang = (label: string) => {
    // trackingGAevent('language_selector', {
    //   searchTerm: '',
    //   position: uniformData(position),
    //   label: uniformData(label),
    //   product: '',
    //   method: '',
    //   type: '',
    // })
  }

  return items?.length ? (
    <div
      className={`${styles.root} ${styles[`root--${variant}`]} ${
        open ? styles['root--open'] : ''
      } ${className}`}
      ref={ref}
    >
      <button
        type="button"
        aria-label={t(open ? 'Chiudi selezione lingua' : 'Apri selezione lingua')}
        onClick={(e) => {
          e.stopPropagation()
          onClick && !open ? onClick('language') : undefined
          setOpen(!open)
        }}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : 'false'}
        id="langDropdownTrigger"
        className={styles.trigger}
      >
        <span className={styles.triggerLabel}>{lang}</span>
        <span className={styles.triggerIcon}>{open ? <ChevronUp /> : <ChevronDown />}</span>
      </button>
      <div className={styles.dropdown} aria-labelledby="langDropdownTrigger">
        <ul>
          {items.map((x) => (
            <li
              key={x.locale}
              className={`${styles.item} ${x.selected ? styles['item--selected'] : ''}`}
            >
              {x.selected ? (
                <span>
                  <span className={styles.itemLabel}>{x.name}</span>
                  <span className={styles.itemIcon}>
                    <Check />
                  </span>
                </span>
              ) : (
                <WLink
                  href={x.url}
                  locale={x.locale}
                  next={x?.unoptimized ? false : true}
                  onClick={() => handleClickLang(x.locale)}
                >
                  {x.name}
                </WLink>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  ) : (
    <></>
  )
}

export default LangDropdown
